import React from 'react';
import { AUDIENCES, RELATIONSHIPS } from '../lib/contributor-fields';

export default function ContributorFields({ value, onChange, includeEmail = true }) {
  return (
    <div className="contributor-fields">
      {includeEmail && (
        <label className="composer-field">
          E-mail <small>(nepovinné, neveřejné)</small>
          <input aria-label="E-mail" type="email" autoComplete="email" maxLength={254} value={value.email || ''} onChange={(event) => onChange('email', event.target.value)} />
        </label>
      )}
      <label className="composer-field">
        Vztah k zesnulému
        <select aria-label="Vztah k zesnulému" value={value.relationship || 'unspecified'} onChange={(event) => onChange('relationship', event.target.value)}>
          {Object.entries(RELATIONSHIPS).map(([id, label]) => (
            <option key={id} value={id}>
              {label}
            </option>
          ))}
        </select>
      </label>
      {value.relationship === 'other' && (
        <label className="composer-field">
          Upřesnění vztahu
          <input aria-label="Upřesnění vztahu" maxLength={255} required value={value.relationship_detail || ''} onChange={(event) => onChange('relationship_detail', event.target.value)} />
        </label>
      )}
      <label className="composer-field">
        Kdo uvidí vzpomínku
        <select aria-label="Kdo uvidí vzpomínku" value={value.audience || 'public'} onChange={(event) => onChange('audience', event.target.value)}>
          {Object.entries(AUDIENCES).map(([id, label]) => (
            <option key={id} value={id}>
              {label}
            </option>
          ))}
        </select>
      </label>
      {value.audience && value.audience !== 'public' && <p className="contributor-access-note">{value.audience === 'private' ? 'Uvidíte pouze vy a správci profilu.' : 'Uvidíte vy, správci a lidé, kterým správce potvrdil příslušný přístup.'} Součástí veřejné projekce nebude.</p>}
    </div>
  );
}
